<template>
  <div
    v-if="activeOffer"
    class="tw:flex tw:mx-auto tw:flex-col tw:w-full tw:md:max-w-screen-lg tw:lg:max-w-screen-xl tw:py-6"
    data-testid="hotel-offers-current-offer"
  >
    <div class="tw:mb-6">
      <p class="tw:text-2xl tw:font-bold tw:mb-1">{{ $t('hotel_offers_product_header') }}</p>
      <p>{{ $t('hotel_offers_product_subtext') }}</p>
    </div>
    <div
      v-if="activeOffer?.expirationDate && daysToExpiration <= 7"
      class="tw:bg-orange-200 tw:rounded-lg tw:mb-6 shadow"
    >
      <p class="tw:text-sm tw:text-gray-800 tw:px-5 tw:py-4" v-if="daysToExpiration === 1">
        {{ $t('hotel_offers_expiry_warning_day') }}
      </p>
      <p class="tw:text-sm tw:text-gray-800 tw:px-5 tw:py-4" v-else>
        {{ $t('hotel_offers_expiry_warning', { ExpirationDate: daysToExpiration }) }}
      </p>
    </div>
    <div class="tw:flex tw:flex-col tw:rounded-lg shadow">
      <ActiveOffer
        source="hotel-offers-page"
        @openRemoveModal="openRemoveModal"
        @openEditOffer="openEditOffer"
        :activeOffer="activeOffer"
      />
    </div>
  </div>
</template>
<script setup>
import { computed } from 'vue'

import ActiveOffer from '@/components/hotelOffers/ActiveOffer.vue'

import { selectedAccommodationId } from '@/layouts/queries'

import appAnalytics from '@/utils/tracking'

const props = defineProps({
  activeOffer: Object,
})

const emit = defineEmits(['openRemoveModal', 'openEditOffer'])
const openRemoveModal = () => emit('openRemoveModal')
const openEditOffer = offer => {
  appAnalytics.track(appAnalytics.events.HO_UPDATE_OFFER_CLICKED, {
    accommodationId: selectedAccommodationId.value,
    offerName: offer?.template,
  })
  emit('openEditOffer', offer)
}

const daysToExpiration = computed(() => {
  const today = new Date()
  const formattedOfferExpirationDate = props.activeOffer?.expirationDate.replace('@', 'T')
  const otherDate = new Date(formattedOfferExpirationDate)
  const differenceInTime = otherDate - today
  const differenceInDays = Math.floor(differenceInTime / (1000 * 60 * 60 * 24))
  return differenceInDays
})
</script>
